module.exports = __webpack_public_path__ + "img/fk.0cc04d34.svg";